import { Box, Typography } from '@mui/material'
import React from 'react'
import { aboutMe } from '../utils/constants'

const AboutMe = () => {
    return (
        <Box p={5}>
            <Box textAlign={'center'}>
                <Typography variant='h4' sx={{ color: '#70FF00' }} display={'inline'}>whoami</Typography><Typography variant='h4' display={'inline'} sx={{ color: '#E0E0E0' }}>( )</Typography>
            </Box>
            <Box>
                <Typography variant='body' color={'#F2F2F2'}>{aboutMe}</Typography>
            </Box>
        </Box>
    )
}

export default AboutMe